export default __webpack_public_path__ + "static/covid-hero-f13fcff1592c9c43c2288571c459601c.jpg";